const styles = {
  locations: {
    maxHeight: '100px',
    paddingRight: '1.143rem',
    gridRow: 1,
    gridColumn: 1,
    '@media (max-width: 991px)': {
      gridRow: 1,
      gridColumn: 1,
      paddingBottom: '1.143rem'
    },
    '@media(max-width:768px)': {
      paddingRight: 0,
      gridRow: 1,
      gridColumn: 1
    }
  }
};

export default styles;
